<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-text>
        <v-card class="pt-1">
          <v-toolbar color="cyan" dark flat>
            <v-toolbar-title>Alterar veículo</v-toolbar-title>
          </v-toolbar>
          <v-card flat>
            <v-card-text>
              <v-flex md12>
                <v-flex md12>
                  <div>
                    Veículo atual:
                    {{ `${currentVehicle.brand} - ${currentVehicle.plate}` }}
                  </div>
                </v-flex>
                <v-flex md12>
                  <v-col>
                    <v-select
                      label="Veículos disponíveis"
                      no-data-text="Nenhum veículo encontrado"
                      prepend-icon="mdi-car"
                      v-model="newVehicle"
                      :items="vehicles"
                      :item-text="item => item.brand + ' - ' + item.plate"
                      :item-value="item => item"
                      required
                    />
                  </v-col>
                  <v-flex md8>
                    <v-col>
                      <v-btn
                        block
                        color="info"
                        class="mt-4 white--text"
                        @click="getAvailibles()"
                      >
                        Buscar veículos
                      </v-btn>
                    </v-col>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-btn color="error" text @click="$emit('disagree')">
          Cancelar
        </v-btn>

        <v-btn color="green darken-1" text @click="changeVehicle">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VehicleController from '../../controllers/VehicleController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import moment from 'moment';

export default {
  created() {
    this.vehicleRequestController = new VehicleRequestController(
      this.$resource
    );
    this.vehicleController = new VehicleController(this.$resource);
    this.getCurrentVehicle();
  },
  props: {
    dialog: Boolean,
    vehicleRequestId: Number,
    currentVehicle: Object,
  },
  data: () => ({
    newVehicle: {},
    vehicles: [],
  }),
  methods: {
    async changeVehicle() {
      this.$emit('agree', this.vehicleRequestId, this.newVehicle);
    },

    async getCurrentVehicle() {
      const vehicleRequest = await this.vehicleRequestController.getById(
        this.vehicleRequestId
      );
      this.currentVehicle = vehicleRequest.vehicle;
      console.log(this.currentVehicle);
    },

    async getAvailibles() {
      try {
        const vehicleRequest = await this.vehicleRequestController.getById(
          this.vehicleRequestId
        );

        await this.getCurrentReservationInfos(vehicleRequest);

        console.log(this.vehicles);
        this.$awn.success('Veículos recuperados com sucesso!');
      } catch (e) {
        console.log(e);
        this.$awn.alert('Não foi possível recuperar os veículos!');
      }
    },

    async getCurrentReservationInfos(vehicleRequest) {
      try {
        const { begin_date, end_date, client } = vehicleRequest;

        const beginDate = moment(begin_date)
          .tz('America/Sao_Paulo')
          .format();

        const endDate = moment(end_date)
          .tz('America/Sao_Paulo')
          .format();

        this.vehicles = [];

        this.vehicles = await this.vehicleController.getVehiclesAvaliablesByAdm(
          beginDate,
          endDate,
          client.id
        );

        return this.vehicles;
      } catch (error) {
        return this.$awn.alert(error.message);
      }
    },
  },
};
</script>
